module.exports = __webpack_public_path__ + "static/media/right.216ddba2.svg";